<template>
	<form ref="PushController" class="push" @submit.prevent="submit">
		<managing-section size="l" header="- 기본 정보">
			<template v-if="isInquiry">
				<managing-box title="푸시번호">{{ idNoti }}</managing-box>
				<managing-box title="등록시간">{{ createdDate }}</managing-box>
			</template>
			<managing-box title="전송형태" :is-required="!isInquiry">
				<p v-if="isInquiry">{{ sendType('name').join(' + ') }}</p>
				<CheckboxList
					v-else
					:value="sendType()"
					:checkboxList="sendTypeList"
					value-name="name"
					@input="sendTypeChange"
				/>
			</managing-box>
			<template v-if="linkType || !isInquiry">
				<managing-box title="연결링크">
					<template v-if="isInquiry">
						<p class="push__link">
							<b>링크구분 : </b>
							{{ linkTypeName }}
						</p>
						<p class="push__link">
							<b>링크값 : </b>
							{{ linkValue }}
						</p>
					</template>
					<template v-else>
						<selector
							:value="linkType"
							:option-list="linkTypeList"
							value-key="id"
							@input="linkTypeChange"
						/>
						<p v-if="checkLinkValue" class="push__link-desc">
							링크값 필수
						</p>
						<input
							v-if="checkLinkValue"
							:value="linkValue"
							type="text"
							placeholder="링크값를 입력해주세요."
							class="push__link-set"
							@input="
								singleMutation('linkValue', $event.target.value)
							"
						/>
					</template>
					<div v-show="linkType" class="push__parsed-link">
						<span class="push__parsed-link__label"> 링크 : </span>
						<input
							:value="sampleLink"
							type="text"
							readonly
							class="push__parsed-link__text"
						/>
						<input
							value="링크복사"
							type="button"
							class="btn push__parsed-link__button"
							v-clipboard:copy="sampleLink"
						/>
						<button
							:disabled="!sampleLink"
							type="button"
							class="btn push__parsed-link__button push__parsed-link__button--short"
							v-text="'짧은 다이나믹 링크 생성'"
							@click="getDynamicLink"
						/>
					</div>
					<div v-show="shortDynamicLink" class="push__parsed-link">
						<span class="push__parsed-link__label">
							짧은 다이나믹 링크 :
						</span>
						<input
							:value="shortDynamicLink"
							type="text"
							readonly
							class="push__parsed-link__text"
						/>
						<input
							:disabled="!shortDynamicLink"
							value="링크복사"
							type="button"
							class="btn push__parsed-link__button"
							v-clipboard:copy="shortDynamicLink"
						/>
					</div>
				</managing-box>
			</template>
			<managing-box title="대상">
				<template v-if="isInquiry">
					<p v-if="type === 'all'">전체 발송</p>
					<p v-else>
						{{ getTypeName(type) }}
						{{ getSearchFilterName(doc) }} (총 {{ userCount }}명)
					</p>
				</template>
				<div v-else class="push__target">
					<RadioList
						:value="type"
						:radio-list="typeList"
						key-name="value"
						value-name="name"
						@input="typeChange($event)"
					/>
					<button
						v-if="type === 'target' && userCount"
						type="button"
						class="btn push__target__btn"
						v-text="'다시 선택'"
						@click="initRegisters"
					/>
					<button
						v-else-if="type === 'target'"
						type="button"
						class="btn push__target__btn"
						v-text="'항번 직접 입력'"
						@click="inputRegisters"
					/>
				</div>

				<div
					v-if="type === 'appoint' && !isInquiry"
					style="display: flex"
				>
					<select
						class="select category-selector__select"
						v-model="search.type"
						@change="typeChange('appoint')"
					>
						<option
							v-for="item in search.typeList"
							:key="item.value"
							:value="item.value"
						>
							{{ item.name }}
						</option>
					</select>

					<template v-if="search.type === 1">
						<search-brand
							ref="searchBrand"
							@change="
								setEventValueToTarget($event, 'clientBrand')
							"
						/>
					</template>

					<template v-if="search.type === 2">
						<category-selector
							:category_level="2"
							ref="categorySelector"
							@change="onSelectCategory"
						/>
					</template>
				</div>

				<div
					v-if="type === 'appoint' && !isInquiry"
					style="display: flex; margin-top: 10px"
				>
					<select
						class="select category-selector__select"
						v-model="search.reviewerGrade"
						@change="onSelectGrade"
					>
						<option
							v-for="item in search.reviewerGradeList"
							:key="item.value"
							:value="item.value"
						>
							{{ item.name }}
						</option>
					</select>

					<button
						type="button"
						class="btn-main blue"
						v-text="'조회'"
						@click="inputSearchRegisters"
					/>
				</div>

				<div
					v-if="
						(type === 'target' ||
							type === 'appoint' ||
							type === 'auto') &&
						userCount
					"
					class="push__target-selected"
				>
					<template v-if="type === 'appoint'">
						<p
							v-if="!isInquiry && search.filterCheck"
							class="push__target-selected__result"
						>
							{{ getTypeName(type) }}
							{{ getSearchFilterName(getDoc()) }} (총
							{{ userCount }}명)
						</p>

						<button
							v-if="search.filterCheck || doc != null"
							type="button"
							class="btn"
							v-text="'선택된 회원 리스트 관리 >'"
							@click="manageRegisters"
						/>
					</template>

					<template v-if="type === 'target' || type === 'auto'">
						<p
							v-if="!isInquiry"
							class="push__target-selected__result"
						>
							총 {{ userCount }}명 선택됨
						</p>
						<button
							type="button"
							class="btn"
							v-text="'선택된 회원 리스트 관리 >'"
							@click="manageRegisters"
						/>
					</template>
				</div>
			</managing-box>
			<managing-box title="발송시간">
				<template v-if="isInquiry">
					{{
						isReserved
							? `예약 발송 (${startDate.replace('T', ' ')})`
							: '즉시 발송'
					}}
				</template>
				<template v-else>
					<RadioList
						:value="isReserved"
						:disabled="type === 'all'"
						:disabled-ids="[false]"
						:radio-list="isReservedList"
						key-name="value"
						value-name="name"
						@input="isReservedChange($event)"
					/>
					<div
						v-if="isReservedList[0].value === isReserved"
						class="push__date"
					>
						<DateBox
							:value="startDate"
							@input="singleMutation('startDate', $event)"
						/>
						<p class="push__date__desc">
							* 예약 발송 시각은 현재시간 기준 30분 이후로
							설정해주세요.
						</p>
						<p class="push__date__desc">
							* 예약 발송 시 매 시 정각부터 5분 주기로 발송됩니다.
							(ex : 10:05, 10:10...)
						</p>
					</div>
				</template>
			</managing-box>
		</managing-section>
		<managing-section
			size="l"
			header="- 푸시 알람 설정"
			sub-header="* 타이틀, 문구에 수신자의 닉네임을 자동으로 넣으려면 넣고 싶은 위치에 {nickname} 을 입력하세요."
		>
			<managing-box title="타이틀">
				<input
					:value="contentTitle"
					:readonly="isInquiry"
					type="text"
					@input="singleMutation('contentTitle', $event.target.value)"
				/>
			</managing-box>
			<managing-box title="문구">
				<textarea
					:value="notiText"
					:readonly="isInquiry"
					@input="singleMutation('notiText', $event.target.value)"
				></textarea>
			</managing-box>
			<managing-box title="알림함 이미지">
				<img-selector
					ref="imgSelector"
					:use-cancel="false"
					:src="bigPicture"
					@change="imgObj = $event"
				/>
			</managing-box>
		</managing-section>
		<div v-if="!isInquiry" class="btn-wrap-main">
			<button
				type="submit"
				class="btn-main blue"
				v-text="'푸시 발송 등록'"
			/>
			<button
				type="button"
				class="btn-main blue bordered"
				v-text="'입력값 초기화'"
				@click="init"
			/>
		</div>
	</form>
</template>
<script>
	import debounce from 'lodash/debounce';
	import { isLinkValueRequired, getShortUrl } from '@/util.js';
	import { mapState, mapGetters } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection';
	import ManagingBox from '@/components/layout/ManagingBox';
	import CheckboxList from '@/components/CheckboxList';
	import Selector from '@/components/Selector';
	import RadioList from '@/components/RadioList';
	import DateBox from '@/components/DateBox';
	import ImgSelector from '@/components/ImgSelector';
	import CategorySelector from '@/components/common/CategorySelector.vue';
	import _ from 'lodash';
	import SearchBrand from '@/components/SearchBrand';

	export default {
		name: 'PushController',
		components: {
			ManagingSection,
			ManagingBox,
			CheckboxList,
			CategorySelector,
			Selector,
			RadioList,
			DateBox,
			ImgSelector,
			SearchBrand,
		},
		data() {
			return {
				imgObj: null,
				sampleLink: '',
				sampleLinkExternal: '',
				clientBrand: {
					brandTitle: '',
					idBrand: null,
				},
				search: {
					type: 1,
					clientType: '1',
					typeList: [
						{ value: 1, name: '브랜드' },
						{ value: 2, name: '카테고리' },
					],
					reviewerGrade: 'master',
					reviewerGradeList: [
						{ value: 'master', name: 'Lv5 마스터' },
						{ value: 'expert', name: 'Lv4 엑스퍼트' },
						{ value: 'collector', name: 'Lv3 콜렉터' },
						{ value: 'explorer', name: 'Lv2 익스플로러' },
						{ value: 'beginner', name: 'Lv1 비기너' },
					],
					firstCategoryName: undefined,
					secondCategoryTargetId: undefined,
					secondCategoryName: undefined,
					filterCheck: false,
				},
				shortDynamicLink: '',
			};
		},
		computed: {
			...mapState('PushController', [
				'isInquiry',
				'idNoti',
				'linkType',
				'linkValue',
				'typeList',
				'type',
				'isReservedList',
				'isReserved',
				'contentTitle',
				'notiText',
				'userList',
				'createdDate',
				'userCount',
				'bigPicture',
				'sendTypeList',
				'startDate',
				'doc',
				'addIdRegisters',
			]),
			...mapGetters({
				getListAddNull: 'getListAddNull',
				getItemById: 'getItemById',
				sendType: 'PushController/sendType',
			}),
			linkTypeList() {
				return this.getListAddNull('newLinkType');
			},
			linkTypeName() {
				const item = this.getItemById('newLinkType', this.linkType);
				return item ? item.name : '';
			},
			checkLinkValue() {
				return this.linkType
					? isLinkValueRequired(this.linkType)
					: false;
			},
		},
		watch: {
			linkType() {
				this.getSampleLink();
			},
			linkValue() {
				this.getSampleLink();
			},
			sampleLink() {
				this.shortDynamicLink = '';
			},
		},
		async created() {
			if (this.$route.query.linkType) {
				this.linkTypeChange(
					this.$route.query.linkType,
					this.$route.query.linkValue
				);
				if (this.$route.query.register_ids) {
					await this.presetRegisterIds(
						this.$route.query.register_ids.split(',')
					);
				}
			}
		},
		methods: {
			linkTypeChange(type, value = '') {
				this.$store.commit('PushController/mutationValue', [
					{ key: 'linkValue', value: value || '' },
					{ key: 'linkType', value: type },
				]);
			},
			getSampleLink: debounce(async function () {
				if (!this.linkType) {
					this.sampleLink = '';
					return;
				}
				const params = { type: this.linkType };
				if (this.linkValue) {
					params.value = this.linkValue;
				}
				const linkValue = this.linkValue
					? `&value=${this.linkValue}`
					: '';
				this.sampleLink = `glowpick://glowpick.com?type=${this.linkType}${linkValue}`;
			}, 700),
			sendTypeChange(nv) {
				this.$store.commit(
					'PushController/mutationValue',
					this.sendTypeList.map(({ id }) => ({
						key: id,
						value: nv.some(item => item === id),
					}))
				);
			},
			singleMutation(key, value) {
				this.$store.commit('PushController/mutationValue', [
					{ key, value },
				]);
			},
			inputRegisters() {
				this.$store.commit('modal/toggleModal', {
					id: 'PushTargetDirect',
				});
			},
			initRegisters() {
				this.$store.commit('PushController/initRegisters');
			},
			async inputSearchRegisters() {
				//검색 api 콜
				try {
					const type = this.search.type;

					//브랜드
					if (type === 1) {
						if (!this.clientBrand.idBrand) {
							alert('브랜드를 선택해주셔야합니다.');
							return;
						}

						//카테고리
					} else {
						if (!this.search.secondCategoryTargetId) {
							alert('2차 카테고리 선택해주셔야합니다.');
							return;
						}
					}

					//외 추가 값도 초기화해줘야함
					this.initRegisters();

					const { data } = await this.$axiosAdmin2.get(
						'/api/registers/search/list',
						{
							params: {
								idSecondCategory:
									this.search.secondCategoryTargetId,
								categoryGrade:
									this.search.secondCategoryTargetId != null
										? this.search.reviewerGrade
										: undefined,
								idBrand: this.clientBrand.idBrand,
								brandGrade:
									this.clientBrand != null
										? this.search.reviewerGrade
										: undefined,
							},
						}
					);

					const contentTotal = data.contentTotal;
					this.$store.commit('PushController/addUserList', {
						userList: data.data,
						count: contentTotal,
					});

					this.search.filterCheck = true;
				} catch (err) {
					console.error(err);
					if (err.response && err.response.status === 452) {
						alert(err.response.data.message);
					} else {
						alert(
							'대상 추가가 불가능 합니다. 개발팀에 문의해주세요.'
						);
					}
				}
			},
			manageRegisters() {
				this.$store.commit('modal/toggleModal', {
					id: 'PushTargetManage',
				});
			},
			isReservedChange(value) {
				this.$store.commit('PushController/mutationValue', [
					{ key: 'isReserved', value },
					{ key: 'startDate', value: '' },
				]);
			},
			typeChange(value) {
				this.$store.commit('PushController/mutationValue', [
					{ key: 'userList', value: [] },
					{ key: 'userCount', value: 0 },
					{ key: 'filterList', value: [] },
					{ key: 'exceptedIdRegisters', value: [] },
				]);
				if (value === 'all') {
					this.singleMutation('isReserved', true);
				}
				this.singleMutation('type', value);

				this.search.reviewerGradeList = [
					{ value: 'master', name: 'Lv5 마스터' },
					{ value: 'expert', name: 'Lv4 엑스퍼트' },
					{ value: 'collector', name: 'Lv3 콜렉터' },
					{ value: 'explorer', name: 'Lv2 익스플로러' },
					{ value: 'beginner', name: 'Lv1 비기너' },
				];
				this.search.reviewerGrade = 'master';

				if (this.type != 'appoint') {
					this.search.type = 1;
				}

				this.search.secondCategoryTargetId = undefined;
				this.clientBrand = {
					brandTitle: '',
					idBrand: null,
				};
			},
			submit() {
				this.$store.commit('PushController/mutationValue', [
					{ key: 'idBrand', value: this.clientBrand.idBrand || null },
					{
						key: 'secondCategoryTargetId',
						value: this.search.secondCategoryTargetId || null,
					},
					{ key: 'grade', value: this.search.reviewerGrade || null },
				]);

				this.$store.dispatch('PushController/submit', this.imgObj);
			},
			init() {
				this.$refs.imgSelector.init();
				this.$store.commit('PushController/initFilter');
				this.$refs.categorySelector.init();
			},
			async presetRegisterIds(register_ids) {
				try {
					const payload = {
						idRegisters: register_ids,
						limit: 0,
						offset: 0,
					};
					this.typeChange('target');

					const { data } = await this.$axiosAdmin2.post(
						'/api/noti/registers/search',
						payload
					);
					const contentTotal = data.contentTotal;
					this.$store.commit('PushController/addUserList', {
						userList: data.data,
						filter: payload,
						count: contentTotal,
					});
				} catch (err) {
					console.error(err);
					if (err.response && err.response.status === 452) {
						alert(err.response.data.message);
					} else {
						alert(
							'대상 추가가 불가능 합니다. 개발팀에 문의해주세요.'
						);
					}
				}
			},
			async reviewGradeSelectBox(args) {
				if (args) {
					try {
						const { data } = await this.$axiosAdmin2.get(
							'/api/common/grade',
							{
								params: {
									idBrand:
										args.idBrand != null
											? args.idBrand
											: undefined,
									idSecondCategory:
										args.idSecondCategory != null
											? args.idSecondCategory
											: undefined,
								},
							}
						);
						let reviewerGradeList = [];

						if (data) {
							if (data.isMaster) {
								reviewerGradeList.push({
									value: 'master',
									name: 'Lv5 마스터',
								});
							}

							if (data.isExpert) {
								reviewerGradeList.push({
									value: 'expert',
									name: 'Lv4 엑스퍼트',
								});
							}

							if (data.isCollector) {
								reviewerGradeList.push({
									value: 'collector',
									name: 'Lv3 콜렉터',
								});
							}

							if (data.isExplorer) {
								reviewerGradeList.push({
									value: 'explorer',
									name: 'Lv2 익스플로러',
								});
							}

							if (data.isBeginner) {
								reviewerGradeList.push({
									value: 'beginner',
									name: 'Lv1 비기너',
								});
							}

							this.search.reviewerGradeList = reviewerGradeList;
							this.search.reviewerGrade =
								reviewerGradeList[0].value;
							this.search.filterCheck = false;
						}
					} catch (err) {
						console.error(err);
						if (err.response && err.response.status === 452) {
							alert(err.response.data.message);
						}
					}
				}
			},
			onSelectCategory(event) {
				this.search.firstCategoryName = event.c1.value || undefined;
				this.search.secondCategoryTargetId =
					event.category2 || undefined;
				this.search.secondCategoryName = event.c2.value || undefined;

				this.reviewGradeSelectBox({
					idSecondCategory: event.category2,
				});
			},
			onSelectGrade(event) {
				this.search.filterCheck = false;
			},
			setEventValueToTarget(event, target) {
				this[target] = event;

				this.reviewGradeSelectBox({
					idBrand: event.idBrand,
				});
			},
			getTypeName(type) {
				if (type == 'auto') return '자동 발송';

				const val = this.typeList.find(
					element => element.value === type
				);
				return val.name;
			},
			getSearchFilterName(doc) {
				if (doc) {
					let searchFilterData = doc.searchFilter;
					let targetFilterData = doc.targetFilter;

					if (searchFilterData) {
						const grade = searchFilterData.grade;
						const gradeName = this.search.reviewerGradeList.find(
							element => element.value === grade
						);

						let idBrand = searchFilterData.idBrand;
						let addIdRegisters = searchFilterData.addIdRegisters;

						let filterTitle = null;

						if (idBrand) {
							filterTitle = `: ${searchFilterData.brandTitle} / ${gradeName.name}`;
						} else {
							filterTitle = `: ${searchFilterData.firstCategoryName} / ${searchFilterData.secondCategoryName} / ${gradeName.name}`;
						}

						if (addIdRegisters && addIdRegisters.length > 0) {
							filterTitle =
								filterTitle + ` 외 ${addIdRegisters.length}명`;
						}

						return filterTitle;
					} else if (targetFilterData) {
						//qna 자동 푸시 관련 문구
						let filterTitle;
						switch (targetFilterData.target) {
							case 'category' || 'brand':
								filterTitle = `: ${doc.targetFilter.target_name} 리뷰어 중 Lv.4,5`;
								break;
							case 'product':
								filterTitle = `: ${doc.targetFilter.target_name} 리뷰어`;
								break;
						}
						return filterTitle;
					}
				}
			},
			getDoc() {
				let doc = {
					searchFilter: {
						firstCategoryName: this.search.firstCategoryName,
						secondCategoryName: this.search.secondCategoryName,
						idBrand: this.clientBrand.idBrand,
						brandTitle: this.clientBrand.brandTitle,
						addIdRegisters: this.addIdRegisters,
						grade: this.search.reviewerGrade,
					},
				};

				return doc;
			},
			getDynamicLink: debounce(async function () {
				try {
					if (!this.sampleLink) {
						this.shortDynamicLink = '';
						return;
					}
					const linkValue = this.linkValue
						? `&value=${this.linkValue}`
						: '';
					this.shortDynamicLink = await getShortUrl(
						`${this.$store.state.env.glowpickDomain}/dynamic-link?type=${this.linkType}${linkValue}`
					);
				} catch (err) {
					console.error(err);
					alert('url 생성하는데 실패했습니다.');
				}
			}, 700),
		},
	};
</script>
<style lang="scss" scoped>
	$lineHeight: 36px;
	$maxWidth: 500px;

	.push__link {
		line-height: $lineHeight;
	}

	.push__link-set {
		display: block;
		max-width: $maxWidth;
		width: 100%;
		margin-top: 12px;

		&:first-child {
			margin-top: 0;
		}
	}

	.push__link-desc {
		margin-top: 12px;
		font-weight: bold;
		color: $red;
	}

	.push__parsed-link {
		display: flex;
		width: 100%;
		margin-top: 12px;
		align-items: center;
	}

	.push__parsed-link__label {
		margin-right: 12px;
		vertical-align: middle;
		font-weight: bold;
		font-size: 0.875rem;
	}

	.push__parsed-link__text {
		max-width: $maxWidth;
		width: 100%;
		margin-right: 12px;
		vertical-align: middle;
		color: $font-blue;
		font-size: 0.875rem;
		font-weight: 700;
	}

	.push__parsed-link__button {
		cursor: pointer;
		vertical-align: middle;
		color: #222;
		font-size: 0.875rem;
		font-weight: 400;

		&--short {
			margin-left: 12px;
		}
	}

	.push__target {
		display: flex;
		align-items: center;
	}

	.push__target__btn {
		margin-left: 12px;
	}

	.push__target-selected {
		@extend .push__target;

		margin-top: 12px;
		font-weight: 700;
	}

	.push__target-selected__result {
		margin-right: 12px;
	}

	.push__date {
		margin: 12px 0 0 0;
	}

	.push__date__desc {
		margin-top: 12px;
		color: $font-blue;
		font-size: 0.875rem;
	}

	.type-selector {
		display: flex;

		.type-selector__select {
			display: block;
			height: 28px;
			margin-left: 1px;
			background: white;
			border: solid 1px #dfe6ee;
			border-radius: 4px;
			font-size: 0.875rem;

			&:first-child {
				margin-left: 0;
			}

			&:focus {
				outline: 1px solid #0099fa;
			}
		}
	}
</style>
